import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import SquareFootageToolView from "./squareFootageToolView";
import {IS_OFFLINE_MODE} from "../../config";

const FakeOfflineSqft = (props) => {

  const {isSquareFootageEnabled, visualizersLoadedLength} = props;
  const [showFake, setShowFake] = useState(IS_OFFLINE_MODE);

  useEffect (() => {
    if (visualizersLoadedLength && showFake) {
      setTimeout(() => {
        setShowFake(false);
      }, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[visualizersLoadedLength]);

  // other popups, modals and so on

  if (!showFake) {
    return null
  }

  return (
    <div className="base-sqft-fake">
      {isSquareFootageEnabled ? <SquareFootageToolView/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
    isSquareFootageEnabled: store.sqftState.isSquareFootageEnabled,
  };
};

export default connect(mapStateToProps)(FakeOfflineSqft)
